import type { ReactNode } from "react";
import { Link } from "wouter";
import AccountActions from "@/components/AccountActions";
import BrandLockup from "@/components/BrandLockup";
import { useAuth } from "@/contexts/AuthContext";

// Update this date whenever the Privacy Policy or Terms of Service changes.
export const LEGAL_LAST_UPDATED = "October 1, 2026";

type LegalPageLayoutProps = {
  title: string;
  children: ReactNode;
};

export default function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  const { session } = useAuth();
  return (
    <div className="paper-shell inner-shell">
      <header className="site-header">
        <BrandLockup />
      </header>

      <main className="legal-layout">
        <article className="legal-content" aria-labelledby="legal-title">
          <div className="legal-heading">
            <p className="eyebrow"><span className="eyebrow-rule" /> Home, Twice</p>
            <h1 id="legal-title">{title}</h1>
            <p className="legal-updated">Last updated: {LEGAL_LAST_UPDATED}</p>
          </div>
          <div className="legal-body">{children}</div>
        </article>
        {session && <AccountActions placement="library" />}
      </main>

      <footer className="site-footer legal-site-footer">
        <Link href="/" className="back-link">Home, Twice</Link>
        <nav className="legal-footer-links" aria-label="Legal">
          <Link href="/privacy">Privacy Policy</Link>
          <Link href="/terms">Terms</Link>
        </nav>
        <span>Published by Kwaderno &amp; Co.</span>
      </footer>
    </div>
  );
}
